import { SystemRoles, UserCredentialType } from "models/ApiEnums";
import i18next from 'i18next';

export function getTranslatedSystemRoles(): KeyValueItem<SystemRoles, string>[] {

    var result: KeyValueItem<SystemRoles, string>[] = [];

    Object.keys(SystemRoles)
        .filter(key => typeof SystemRoles[key] === 'number')
        .forEach(key => {
            result.push({ key: SystemRoles[key], value: i18next.t("sys:SystemRoles." + key) });
        });

    return result;
}


export function getTranslatedUserCredentialsType(): KeyValueItem<UserCredentialType, string>[] {

    var result: KeyValueItem<UserCredentialType, string>[] = [];

    Object.keys(UserCredentialType)
        .filter(key => typeof UserCredentialType[key] === 'number')
        .forEach(key => {
            result.push({ key: UserCredentialType[key], value: i18next.t("sys:UserCredentialType." + key) });
        });

    return result;
}
